<template>
  <div class="headers">
    <div class="home-area">
      <div class="header-left">
        <div class="unLogin" v-if="!isLogin">
          <div>您好，请<router-link to="/login">登录</router-link></div>
          <span @click="$router.push('/login')">免费注册</span>
        </div>
        <div class="login" v-else>
          <span>{{ userinfo?.company?.name || '' }}</span>
          <img @click="$router.push('/certification/company')" v-if="status == 2" src="@/assets/images/header/certified.png" alt="">
          <img @click="$router.push('/certification/company')" v-else src="@/assets/images/header/uncertified.png" alt="">
          <span class="logout" @click="logout">退出</span>
        </div>
      </div>
      <div class="header-right">
        <el-dropdown size="mini" @command="handleClick">
          <span class="el-dropdown-link">工作台系统</span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="item in list" :key="item.id" :command="item.url">{{ item.title }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-divider direction="vertical"></el-divider>
        <el-badge :value="msgNumber" :max="99" class="item" :hidden="msgNumber == 0||!isLogin">
          <span @click="handleClick(messageUrl)">消息中心</span>
        </el-badge>
      </div>
    </div>
  </div>
</template>

<script>
import { getMessageUnread } from "@/api/message";
export default {
  name: 'homeHeader',
  data() {
    return {
      msgNumber: 0,
      messageUrl: `${process.env.VUE_APP_EXTERNAL_LINK}/message`
    }
  },
  computed: {
    userinfo() {
      return this.$store.getters["user/userInfo"];
    },
    status() {
      return this.userinfo?.company?.status || ''
    },
    isLogin() {
      return this.$store.getters["user/isLogin"];
    },
    list() {
      return [
        {
          id: 1,
          title: '采购业务',
          url: `${process.env.VUE_APP_EXTERNAL_LINK}/purchase`,
        },
        {
          id: 2,
          title: '销售业务',
          url: `${process.env.VUE_APP_EXTERNAL_LINK}/sale`
        },
        {
          id: 3,
          title: '物流系统',
          url: `${process.env.VUE_APP_LOGISTICS_LINK}`
        },
        {
          id: 4,
          title: '票据系统',
          url: `${process.env.VUE_APP_YLKJ_TICKET_SYSTEM}`
        },
        {
          id: 5,
          title: '发票系统',
          url: `${process.env.VUE_APP_INVOICE_SYSTEM}`
        },
        {
          id: 6,
          title: '金融系统',
          url: `${process.env.VUE_APP_FINANCE_LINK}`
        },
        {
          id: 7,
          title: '电子钱包',
          url: `/finance`
        },
        {
          id: 8,
          title: '易缆AI',
          url: `${process.env.VUE_APP_AI_LINK}`
        },
        {
          id: 9,
          title: '仓储系统',
          url: 'https://wms-rfid.badoodigital.com'
        },
        {
          id: 10,
          title: '物联系统',
          url: `${process.env.VUE_APP_IOT_LINK}`
        },
      ]
    }
  },
  mounted() {
    this.polling();
  },
  methods: {
    logout() {
      this.$store.dispatch('user/logout')
    },
    handleClick(url) {
      if (url) {
        if (url.startsWith('http')) {
          window.open(url, '_self');
        } else {
          this.$router.push(url);
        }
      }
    },
    getMessageUnread() {
      if (this.isLogin) {
        getMessageUnread().then(({ data }) => {
          if (data.code == 0) {
            this.msgNumber = data.data;
          }
        });
      }
    },
    polling() {
      this.getMessageUnread();
      let mytimer = setInterval(() => {
        this.getMessageUnread();
      }, 30000);
      this.$on("hook:beforeDestroy", () => {
        clearInterval(mytimer);
        mytimer = null;
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.headers {
  background: #eee;
  height: 30px;
  min-width: 1200px;
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #666666;
  .home-area {
    display: flex;
    align-items: center;
    margin: 0 auto;
    width: 1200px;
    height: 100%;
    justify-content: space-between;
    .header-left {
      display: flex;
      align-items: center;
      .login {
        display: flex;
        align-items: center;
        img {
          margin-left: 5px;
          margin-right: 20px;
          cursor: pointer;
        }
        .logout {
          cursor: pointer;
        }
      }
      .unLogin {
        display: flex;
        align-items: center;
        div{
          a{
            color: #2489f2;
            text-decoration: none;
          }
        }
        span:nth-child(2) {
          margin-left: 20px;
          cursor: pointer;
          color: #e60012;
        }
      }
    }
    .header-right {
      display: flex;
      align-items: center;
      .el-dropdown-link{
        font-size: 12px;
        cursor: pointer;
      }
      .item {
        cursor: pointer;
      }
    }
  }
}
</style>
